/**
 * SectionDivider
 * A gradient horizontal rule that creates visual flow between page sections.
 * Replaces <hr> or plain border-t dividers throughout the marketing site.
 */

interface SectionDividerProps {
  className?: string;
  variant?: 'default' | 'subtle' | 'bright';
}

export const SectionDivider = ({ className = '', variant = 'default' }: SectionDividerProps) => {
  const getDividerClass = (v: 'default' | 'subtle' | 'bright'): string => {
    if (v === 'subtle') return 'h-px bg-gradient-to-r from-transparent via-white/5 to-transparent';
    if (v === 'bright') return 'h-px bg-gradient-to-r from-transparent via-white/20 to-transparent';
    return 'section-divider';
  };

  return (
    <div className={`${getDividerClass(variant)} w-full my-0 ${className}`} aria-hidden="true" />
  );
};

export default SectionDivider;
